import axios from 'axios';
import Cookies from 'js-cookie'
import router from '@/router';
import AccessToken from '@/services/auth-central';

const ACCESS_TOKEN = AccessToken();

const BASE_URI = process.env.API_BASE_URI;
const GOCHAT_API_URL = process.env.GOCHAT_API_URL;
const GOCHAT_URL = process.env.API_URL;
const GOCHAT_TOKEN = ACCESS_TOKEN.token;

let config = {
    headers: {
        Authorization: `Bearer ${GOCHAT_TOKEN}`,
    }
}

class AuthService {
    async login(user) {
        let data = {
            'email': user.email,
            'password': user.password,
            'merchant_id': user.merchant_id
        };
        return await axios.post(GOCHAT_URL + '/v2/login', data).then(response => {
            return response;
            // console.log(response.data.data);
            // if (response.data.data.token) {
            //     Cookies.set('centralToken', result.data.data.token)
            // }
        });
    }

    async autologin(query) {
        // let data = {
        //     request_id: query.request_id,
        //     token: query.token
        // };

        // console.log(query)

        // try {
        //     return await axios.post(GOCHAT_URL + `/v2/login/auth`, data, {
        //         headers: {
        //             // 'Content-Type': 'text/plain',
        //             // 'Access-Control-Allow-Origin': '*'
        //         }
        //     })
        // } catch (err) {
        //     return err;
        // }
        return await axios
            .post(GOCHAT_URL + `/v2/login/auth`, query)
            .catch(error => {
                throw error;
            });
    }

    async logOut(data = []) {
        Cookies.remove('centralToken')
        return true
        // await axios.post(GOCHAT_URL + '/v1/auth/logout', data, config);
    }

    async register(user) {
    }
}

export default new AuthService()



// WEBPACK FOOTER //
// ./src/services/auth.service.js